import React from 'react';
import './divider.scss';
import { MAIN_CONFIG } from '../../../config/main';

export default ({ color = MAIN_CONFIG.COLORS.fillBeige, className, solid = false }) => {
    return (
        <div className={`divider ${className} ${solid ? 'solid' : ''}`} style={{ borderColor: color }}> </div>
    );
};
